class SubscriptionFeatureController extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.id = this.getAttribute('data-section-id');
    this.select = this.querySelector(`#subscription-stage--${this.id}`);
    this.stageContentWrappers = this.querySelectorAll('.subscription-feature__stage-content-inner');

    this.activeWrapper = this.querySelector('.subscription-feature__stage-content-inner[aria-hidden="false"]');
    this.badgeText = this.activeWrapper.getAttribute('data-badge-text');
    this.badgePercent = this.activeWrapper.getAttribute('data-badge-percent');
    this.parent = this.closest('.subscription-feature__container');
    this.badgeTextElements = this.parent.querySelectorAll('.subscription-feature__badge-text');
    this.badgePercentElements = this.parent.querySelectorAll('.subscription-feature__badge-percent');

    if (this.badgeText === '' && this.badgePercent === '') {
      this.badgeWrappers = this.parent.querySelectorAll('.subscription-feature__badge');
      this.badgeWrappers.forEach((badgeWrapper) => {
        badgeWrapper.style.display = 'none';
      })
    }

    if (this.badgeText !== '' && this.badgePercent !== '') {
      this.badgeTextElements.forEach((textElement) => {
        textElement.textContent = this.badgeText;
      });
    }

    if (this.badgeText !== '' && this.badgePercent !== '') {
      this.badgePercentElements.forEach((badgeElement) => {
        badgeElement.textContent = this.badgePercent;
      });
    }


    if (!this.select || this.stageContentWrappers.length === 0) return;

    this.select.addEventListener('change', this.onStageChange.bind(this));
  }

  onStageChange(event) {
    const selectedValue = event.target.value;
    this.updateVisibility(selectedValue);
  }

  updateVisibility(activeValue) {
    this.stageContentWrappers.forEach((wrapper) => {
      const stageId = wrapper.getAttribute('data-stage-id');
      const isActive = stageId === activeValue;

      wrapper.setAttribute('aria-hidden', !isActive);
      // wrapper.style.display = isActive ? 'block' : 'none';
    });
    const activeWrapper = this.querySelector('.subscription-feature__stage-content-inner[aria-hidden="false"]');
    const badgeText = activeWrapper.getAttribute('data-badge-text');
    const badgePercent = activeWrapper.getAttribute('data-badge-percent');
    const parent = this.closest('.subscription-feature__container');
    const badgeTextElements = parent.querySelectorAll('.subscription-feature__badge-text');
    const badgePercentElements = parent.querySelectorAll('.subscription-feature__badge-percent');
    const badgeWrappers = this.parent.querySelectorAll('.subscription-feature__badge');

    badgeTextElements.forEach((textElement) => {
      textElement.textContent = badgeText;
    });

    badgePercentElements.forEach((badgeElement) => {
      badgeElement.textContent = badgePercent;
    });

    if (badgeText === '' && badgePercent === '') {
      badgeWrappers.forEach((badgeWrapper) => {
        badgeWrapper.style.display = 'none';
      })
    } else {
      badgeWrappers.forEach((badgeWrapper) => {
        badgeWrapper.style.display = 'flex';
      })
    }
  }
}

customElements.define('subscription-feature-controller', SubscriptionFeatureController);